/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ListAiSystemHintsParams,
  PaginatedAiSystemHints,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary List of AI System Hints
 */
export const listAiSystemHints = (
    params?: MaybeRefOrGetter<ListAiSystemHintsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedAiSystemHints>(
      {url: `/ai/system_hints`, method: 'GET',
        params, signal
    },
      );
    }




export const getListAiSystemHintsQueryKey = (params?: MaybeRefOrGetter<ListAiSystemHintsParams>,) => {
    return [
    'ai','system_hints', ...(params ? [params] : [])
    ] as const;
    }


export const getListAiSystemHintsQueryOptions = <TData = Awaited<ReturnType<typeof listAiSystemHints>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<ListAiSystemHintsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiSystemHints>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAiSystemHintsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiSystemHints>>> = ({ signal }) => listAiSystemHints(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAiSystemHints>>, TError, TData>
}

export type ListAiSystemHintsQueryResult = NonNullable<Awaited<ReturnType<typeof listAiSystemHints>>>
export type ListAiSystemHintsQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary List of AI System Hints
 */

export function useListAiSystemHints<TData = Awaited<ReturnType<typeof listAiSystemHints>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<ListAiSystemHintsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiSystemHints>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAiSystemHintsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






